import {
	SP_ORDER_COMMENTS_LIST_FILTERED,
	SP_ORDER_COMMENTS_LIST_FILTERED_SUCCESS,
	SP_ORDER_COMMENTS_LIST_FILTERED_ERROR,
	SP_ORDER_COMMENT_CREATE,
	SP_ORDER_COMMENT_CREATE_SUCCESS,
	SP_ORDER_COMMENT_CREATE_ERROR
} from "../actions/spOrderComments";
import SpOrderCommentsService from '@/services/spOrderComments';

const state = {
};

const getters = {
};

const actions = {
	[SP_ORDER_COMMENT_CREATE]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.spOrderComment.id,
			sp_order_id: data.spOrderComment.sp_order_id,
			content: data.spOrderComment.content
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_COMMENT_CREATE);
			SpOrderCommentsService.create(requestData)
				.then(data => {
					commit(SP_ORDER_COMMENT_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(SP_ORDER_COMMENT_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDER_COMMENTS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.spOrderId) {
			requestData.spOrderIdFilter = data.tableProps.inputFilter.spOrderId;
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_COMMENTS_LIST_FILTERED);
			SpOrderCommentsService.listFiltered(requestData)
				.then(responseData => {
					commit(SP_ORDER_COMMENTS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDER_COMMENTS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	}
};

const mutations = {
	[SP_ORDER_COMMENTS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_COMMENTS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_COMMENTS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[SP_ORDER_COMMENT_CREATE]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_COMMENT_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_COMMENT_CREATE_ERROR]: state => {
		state.status = 'error';
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};